function initializeSurveyFirstAnswer() {
  const form = document.querySelector('form[data-first-answer-endpoint]');

  if (!form) {
    return;
  }

  const firstAnswerEndpoint = form.dataset.firstAnswerEndpoint;
  const scoreInputs = form.querySelectorAll('input[name="CA_766"]');
  let debounceTimer = null;
  let activeRequest = null;
  let latestScore = null;

  function captureLatestScore() {
    if (latestScore === null) {
      return;
    }

    if (activeRequest) {
      activeRequest.abort();
    }

    const sentScore = latestScore;
    const requestController = new AbortController();
    activeRequest = requestController;

    fetch(firstAnswerEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ score: sentScore }),
      signal: requestController.signal
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Não foi possível processar a resposta.');
        }
      })
      .catch(function (error) {
        if (error.name === 'AbortError') {
          return;
        }
      })
      .finally(function () {
        if (activeRequest === requestController) {
          activeRequest = null;
        }
      });
  }

  function scheduleCapture() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(captureLatestScore, 800);
  }

  scoreInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      latestScore = parseInt(input.value, 10);
      scheduleCapture();
    });
  });

  form.addEventListener('submit', function () {
    clearTimeout(debounceTimer);

    if (activeRequest) {
      activeRequest.abort();
      activeRequest = null;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSurveyFirstAnswer);
} else {
  initializeSurveyFirstAnswer();
}
